import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form, Tab, Nav, Alert } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import { sports, bookingSubscriptionExpirationType, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { Information } from "iconsax-react";
import { useFederations } from "../../../../../hooks/useFederations";
import UserSubscriptionsTable from "../userSubscriptions/index";
import LinkAcquisto from "../../../../components/LinkAcquisto/LinkAcquisto";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";

import { conMotivo } from "../../../../components/Util/erroreServer";
import { prezzoPerCampo } from "../../../../components/Util/prezzi";
export const SubscriptionsView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { profile: profileData } = useProfile({ 
        autoFetch: true, 
        includeTitles: true 
    });
    
    const { federations } = useFederations();
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED';
    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const priceFieldsLocked = (fieldName) => (fieldName === 'standard_price' || fieldName === 'iva_5_percent') && sdiEnabledNoVat;

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [enabledSports, setEnabledSports] = useState([]);

    useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }
    }, [profileData]);

    const [pictureModalShowed, setPictureModalShowed] = useState(false);

    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);
    // Chi tiene il libro soci puo' anche vendere l'abbonamento che rende soci:
    // associazioni, societa' sportive dilettantistiche e societa' di capitali.
    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });



	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const bookingSubscriptions = await apiClient.getBookingSubscriptionById(token, id);
					setLoadingShowed(false);
                    
                    if(bookingSubscriptions) {
                        const elementFormData = {
                            id: bookingSubscriptions.id,
                            clubId: bookingSubscriptions.clubId,
                            name: bookingSubscriptions.name, 
                            sportType: bookingSubscriptions.sportType,
                            expiration_type: bookingSubscriptions.expiration_type,
                            standard_price: prezzoPerCampo(bookingSubscriptions.standard_price),
                            member_price: prezzoPerCampo(bookingSubscriptions.member_price),
                            federated_price: prezzoPerCampo(bookingSubscriptions.federated_price),
                            fitcoin_cashback: bookingSubscriptions.fitcoin_cashback,
                            payable_in_club: bookingSubscriptions.payable_in_club,
                            payable_stripe: bookingSubscriptions.payable_stripe,
                            payable_bank: bookingSubscriptions.payable_bank,
                            vat_rate: bookingSubscriptions.vat_rate,
                            vat_nature: bookingSubscriptions.vat_nature,
                            iva_5_percent: bookingSubscriptions.iva_5_percent,
                            auto_renew: bookingSubscriptions.auto_renew,
                            grants_club_membership: bookingSubscriptions.grants_club_membership,
                            grants_federated_status: bookingSubscriptions.grants_federated_status,
                            federation_code: bookingSubscriptions.federation_code || '',
                            status: bookingSubscriptions.status,
                            description: bookingSubscriptions.description,
                            subscriptionPicture: bookingSubscriptions.subscriptionPicture
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // L'abbonamento non dipende dal profilo: chiederlo solo dopo la risposta di /profile
        // metteva due attese in fila invece che in parallelo.
        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value
                || tokenDetails.clubNature === tipologiaStruttura.SSD.value
                || tokenDetails.clubNature === tipologiaStruttura.CAPITAL_COMPANY.value) {
                setShowingSociOptions(true);
            }
            // Imposta i metodi di pagamento abilitati
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const [formData, setFormData] = useState({
        id: '',
        clubId: '',
        name: '', 
        sportType: '',
        expiration_type: '',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        auto_renew: false,
        grants_club_membership: false,
        grants_federated_status: false,
        federation_code: '',
        status: '',
        subscriptionPicture: ''
    });

    // Titolo della pagina con il nome dell'abbonamento (appena caricato)
    usePageTitle(formData?.name || null); // titolo = solo il nome del prodotto


    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // I prezzi restano come li scrive l'operatore («55,50»): diventano numeri all'invio.
        const processedValue = value;
        
        setFormData(prevState => ({
            ...prevState,
            [name]: processedValue
        }));
    };

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const getAvailableFederations = () => {
        if (!formData.sportType || !federations.length) return [];

        // Organismi configurati dalla struttura per questo sport
        const clubSport = profileData?.club?.sports?.find(s => s.sportType === formData.sportType);
        const clubOrganisms = clubSport?.sportPromotionBody || [];

        if (clubOrganisms.length === 0) return [];

        return federations
            .filter(fed => clubOrganisms.includes(fed.code))
            .map(fed => ({
                value: fed.code,
                label: `${fed.code} - ${fed.description}`
            }));
    };

    const handleSaveAll = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return;
            const tokenDetails = JSON.parse(tokenDetailsString);
            const token = tokenDetails.idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const updateData = {
                id: formData.id,
                sportType: formData.sportType,
                clubId: formData.clubId,
                name: formData.name,
                expiration_type: formData.expiration_type,
                status: formData.status,
                payable_in_club: formData.payable_in_club,
                payable_bank: formData.payable_bank,
                payable_stripe: formData.payable_stripe,
                vat_rate: formData.vat_rate,
                vat_nature: formData.vat_nature || undefined,
                iva_5_percent: formData.iva_5_percent,
                auto_renew: formData.auto_renew,
                standard_price: formData.standard_price,
                grants_club_membership: formData.grants_club_membership,
                grants_federated_status: formData.grants_federated_status,
                federation_code: formData.grants_federated_status ? formData.federation_code : '',
                description: formData.description,
                member_price: formData.member_price,
                federated_price: formData.federated_price,
                fitcoin_cashback: formData.fitcoin_cashback,
                subscriptionPicture: formData.subscriptionPicture
            };
            if (formData.newSubscriptionPicture) {
                updateData.newSubscriptionPicture = {
                    content: formData.newSubscriptionPicture,
                    name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
                };
            }
            Object.keys(updateData).forEach(key => { if (updateData[key] === '') delete updateData[key]; });
            const result = await apiClient.updateBookingSubscription(token, updateData);
            setLoadingShowed(false);

            if (result && result.error) {
                setModalTitle("Errore durante l'aggiornamento");
                setModalText(result.error);
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/subscriptions');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error updating subscription:', error);
            setModalTitle("Errore durante l'aggiornamento");
            setModalText(conMotivo("Si è verificato un errore durante l'aggiornamento dell'abbonamento."));
            setModalShowed(true);
        }
    };

    const renderEditableField = (fieldName, label, type = 'text', options = null) => {
        const value = formData[fieldName];
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked(fieldName);
        const disabledTitle = priceFieldsLocked(fieldName)
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        const disabledStyle = { color: 'var(--sid-text)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal' };

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">{label}</Form.Label>
                {options ? (
                    <Select
                        className="mt-2"
                        styles={sidSelectStyles}
                        isDisabled={disabled}
                        name={fieldName}
                        value={options.find(option => option.value === value)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, fieldName)}
                        options={options}
                    />
                ) : type === 'textarea' ? (
                    <Form.Control
                        disabled={disabled}
                        as="textarea"
                        rows={10}
                        className="mt-2"
                        style={disabled ? disabledStyle : undefined}
                        name={fieldName}
                        value={value || ''}
                        onChange={handleChange}
                    />
                ) : (
                    <Form.Control
                        disabled={disabled}
                        className="mt-2"
                        style={disabled ? { ...disabledStyle, fontSize: '14px' } : undefined}
                        type={type === 'prezzo' ? 'text' : type}
                        inputMode={type === 'prezzo' ? 'decimal' : undefined}
                        name={fieldName}
                        value={(value || value === 0) ? value : ''}
                        onChange={handleChange}
                    />
                )}
            </div>
        );
    };

    // L'IVA non passa dal renderer generico: le opzioni a 0% differiscono per
    // codice Natura, quindi la voce selezionata non si trova confrontando un
    // singolo valore. Stessa logica di abilitazione degli altri campi prezzo.
    const renderVatField = () => {
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked('iva_5_percent');
        const disabledTitle = priceFieldsLocked('iva_5_percent')
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">IVA</Form.Label>
                <Select
                    className="mt-2"
                    styles={sidSelectStyles}
                    isDisabled={disabled}
                    name="vat_rate"
                    value={findVatOption(formData)}
                    onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                    options={VAT_OPTIONS}
                />
            </div>
        );
    };

    // Campi si'/no: un interruttore su una riga, non una tendina in mezza colonna
    const renderSwitchField = (fieldName, label) => {
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        return (
            <div className="sid-switch-row" title={!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined}>
                <Form.Check
                    type="switch"
                    id={`switch-${fieldName}`}
                    label={label}
                    disabled={!isEditableStatus}
                    checked={!!formData[fieldName]}
                    onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
                />
            </div>
        );
    };


    // Eliminazione definitiva, disponibile anche ad abbonamento attivo o non attivo:
    // il server la rifiuta quando l'abbonamento e' stato venduto e in quel caso
    // mostriamo il motivo che arriva da lui.
    const handleElimina = () => {
        setOnContinue(() => () => eliminaAbbonamento());
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? L'abbonamento sarà eliminato definitivamente dalla tua struttura, insieme agli ordini non ancora pagati. Non è possibile eliminarlo se ha acquisti pagati: in quel caso puoi impostarlo come Non attivo.");
    };

    const eliminaAbbonamento = async () => {
        setConfirmShowed(false);

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) {
                return;
            }
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const result = await apiClient.deleteBookingSubscription(token, id);
            setLoadingShowed(false);

            if (!result || result.error) {
                setModalTitle("Eliminazione non riuscita");
                setModalText(result && result.error ? result.error : conMotivo("Si è verificato un errore durante la cancellazione"));
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/subscriptions');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in eliminaAbbonamento: ' + error);
            setModalTitle("Eliminazione non riuscita");
            setModalText(conMotivo("Si è verificato un errore durante la cancellazione"));
            setModalShowed(true);
        }
    };

    // Stato dalla chip accanto al titolo: il cambio si registra subito e si resta nella scheda
    const cambiaStato = async (attiva) => {
        if (attiva && billingNotConfirmed) {
            setModalTitle("Documenti fiscali non ancora validati");
            setModalText("Non è possibile attivare la vendita di questo prodotto finché i documenti fiscali della tua struttura non sono stati validati. Per pubblicare prodotti e renderli acquistabili nell'App SportId Player devi prima configurare e confermare il metodo di fatturazione nella sezione La mia struttura → Documenti fiscali. Nel frattempo puoi continuare a creare prodotti e salvarli come bozza.");
            setModalShowed(true);
            return { annullato: true };
        }
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const result = await new MyApiClient().changeSubscriptionStatus(token, id, nuovo);
        if (result && result.error) return { error: result.error };
        setFormData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: formData?.status === 'PURCHASABLE',
        bozza: formData?.status === 'DRAFT',
        onCambia: cambiaStato,
    });

    const goBack = () => {
        navigate('/struttura/booking/subscriptions');
	};

	return (
		<>
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <ProductImageUploader
                show={pictureModalShowed}
                onClose={() => setPictureModalShowed(false)}
                onSave={(base64String) => {
                    setPictureModalShowed(false);
                    setFormData(prev => ({ ...prev, newSubscriptionPicture: base64String }));
                }}
                titolo="Immagine dell'abbonamento"
            />

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            {billingNotConfirmed && (
                <Alert variant="warning" className="d-flex align-items-start gap-2 text-dark" style={{ marginBottom: '1rem' }}>
                    <Information size="20" className="mt-1 flex-shrink-0" />
                    <div>
                        <strong>Metodo di fatturazione non configurato.</strong> Per pubblicare prodotti e renderli acquistabili nell'App SportId Player è necessario configurare e confermare il metodo di fatturazione nella sezione <strong>La mia struttura → Documenti fiscali</strong>. Puoi continuare a creare prodotti e salvarli come bozza.
                    </div>
                </Alert>
            )}

            <Row className="align-items-start mt-0">
                <div className="col-xl-12">
                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey="informazioni">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="informazioni">
                                        Informazioni generali
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="acquisti">
                                        Vendite
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            {/* Link pubblico per vendere l'abbonamento via email o WhatsApp */}
                            {formData.status !== 'DRAFT' && (
                                <LinkAcquisto productType="subscription" productId={id} nomeProdotto={formData.name} attivo={formData.status === 'PURCHASABLE'} />
                            )}
                            </div>
                            <Row className="align-items-start mt-4">
                                <div className="col-12">
                                    <Tab.Content mountOnEnter>
                                        <Tab.Pane eventKey="informazioni">
                                            <Card>
                                                <Card.Body className="sid-card-body--spaced">
                                                    <Row className="g-4">
                                                        <Col md={6}>
                                                            {renderEditableField('name', 'Nome abbonamento', 'text')}
                                                        </Col>
                                                        <Col md={6}>
                                                            {renderEditableField('sportType', 'Sport', 'select', enabledSports)}
                                                        </Col>
                                                        <Col md={6}>
                                                            {renderEditableField('expiration_type', 'Durata', 'select', bookingSubscriptionExpirationType)}
                                                        </Col>
                                                        <Col md={12}>
                                                            {renderEditableField('description', 'Descrizione', 'textarea')}
                                                        </Col>
                                                        <Col md={12}>
                                                            <Form.Label>Foto</Form.Label>
                                                            <div className="sid-photo-field">
                                                                <div className="sid-photo-field__preview">
                                                                    {formData.newSubscriptionPicture ?
                                                                        <img src={`data:image/jpeg;base64,${formData.newSubscriptionPicture}`} alt="" />
                                                                    : formData.subscriptionPicture ?
                                                                        <img src={formData.subscriptionPicture} alt="" />
                                                                    :
                                                                        <span>Nessuna foto</span>
                                                                    }
                                                                </div>
                                                                {(formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED') && (
                                                                    <Button size="sm" variant="outline-dark" onClick={() => setPictureModalShowed(true)}>
                                                                        {(formData.newSubscriptionPicture || formData.subscriptionPicture) ? 'Sostituisci foto' : 'Carica foto'}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Prezzi</h5>
                                                    <Row className="g-4">
                                                        <Col md={3}>
                                                            {renderEditableField('standard_price', 'Prezzo standard', 'prezzo')}
                                                        </Col>
                                                        {!formData.grants_federated_status && (
                                                        <Col md={3}>
                                                            {renderVatField()}
                                                        </Col>
                                                        )}
                                                        {showingTesseratiOptions &&
                                                        <Col md={3}>
                                                            {renderEditableField('federated_price', 'Prezzo tesserati / soci', 'prezzo')}
                                                        </Col>
                                                        }
                                                        <Col md={3}>
                                                            {renderEditableField('fitcoin_cashback', 'Cashback Fitcoin', 'number')}
                                                        </Col>
                                                    </Row>

                                                    {(showingTesseratiOptions || showingSociOptions) && (
                                                    <>
                                                        <h5 className="sid-form-section">Privilegi</h5>
                                                        <div className="sid-switch-inline">
                                                            {showingTesseratiOptions && renderSwitchField('grants_federated_status', 'Rende tesserato nello sport')}
                                                            {showingSociOptions && renderSwitchField('grants_club_membership', 'Rende socio')}
                                                        </div>
                                                        {showingSociOptions && (
                                                            <small className="text-muted d-block mt-2">
                                                                Chi acquista entra nel libro soci quando l'ordine risulta pagato.
                                                                Se il player era gia' stato ammesso dall'assemblea, l'acquisto ne
                                                                salda la quota.
                                                                <br />
                                                                <strong>Gli abbonamenti che rendono socio non compaiono nel catalogo dell'app:</strong>
                                                                {' '}si vendono dal Manager, in vendita manuale.
                                                            </small>
                                                        )}
                                                        {showingTesseratiOptions && formData.grants_federated_status && (
                                                        <Row className="g-4 mt-0">
                                                            <Col md={6}>
                                                                {renderEditableField('federation_code', 'Organismo', 'select', getAvailableFederations())}
                                                            </Col>
                                                        </Row>
                                                        )}
                                                    </>
                                                    )}

                                                    <h5 className="sid-form-section">Forme di pagamento</h5>
                                                    <div className="sid-switch-inline">
                                                        {renderSwitchField('payable_in_club', 'Acquisto pagabile in struttura')}
                                                        {paymentMethods.stripe_enabled && renderSwitchField('payable_stripe', 'Acquisto pagabile su Stripe')}
                                                        {paymentMethods.bank_transfer_enabled && renderSwitchField('payable_bank', 'Acquisto pagabile con bonifico')}
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                            <div className="d-flex justify-content-between align-items-center gap-4 mt-4">
                                                <Link onClick={() => handleElimina()} to="#" className="btn btn-danger light">Elimina abbonamento</Link>
                                                <div className="d-flex gap-4">
                                                    <button type="button" className="btn btn-dark light" onClick={() => goBack()}>Indietro</button>
                                                    {(formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED') && (
                                                        <Button onClick={handleSaveAll} className="btn btn-primary">Salva</Button>
                                                    )}
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="acquisti">
                                            <UserSubscriptionsTable
                                                subscriptionId={id}
                                                headerButtons={formData.status === 'PURCHASABLE' && (
                                                    <Link to={`/struttura/booking/userSubscriptions/new?subscriptionId=${id}`} className="btn btn-primary btn-sm btn-add">
                                                        <i className="fas fa-plus me-2"></i>
                                                        Nuova Vendita
                                                    </Link>
                                                )}
                                            />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </Row>
		</>
	)

}
export default SubscriptionsView;